
export const ADD_POINTS = "ADD_POINTS";
export const SET_TOTAL_POINTS = "SET_TOTAL_POINTS";
export const SET_LAST_EARNED_POINTS = "SET_LAST_EARNED_POINTS";
